import React from "react";
import { createRoot } from "react-dom/client";
import { HelmetProvider } from 'react-helmet-async';
import App from "./App";
import "./styles/tailwind.css";
import "./styles/index.css";
import "./i18n/config";

const container = document.getElementById("root");
const root = createRoot(container);

root.render(
    <HelmetProvider>
        <App />
    </HelmetProvider>
);
